<script setup>
import { RouterLink } from 'vue-router'
import { ROUTES } from '../../../core/config/constants.js'
</script>

<template>
  <section class="cta-section">
    <div class="container">
      <div class="cta-card">
        <div class="cta-content">
          <h2 class="cta-title">מוכנים להתחיל?</h2>
          <p class="cta-desc">
            הצטרפו לאלפי לקוחות מרוצים בכל רחבי הארץ. פתיחת חשבון מהירה ופשוטה.
          </p>
        </div>
        <div class="cta-actions">
          <RouterLink :to="{ name: ROUTES.LOGIN }" class="btn-cta">
            <span>התחבר עכשיו</span>
            <svg
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </RouterLink>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

@media (min-width: 768px) {
  .container {
    padding: 0 var(--spacing-lg);
  }
}

.cta-section {
  padding: var(--spacing-xl) 0;
  background: var(--bg-secondary);
}

@media (min-width: 768px) {
  .cta-section {
    padding: var(--spacing-3xl) 0;
  }
}

.cta-card {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xl);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--spacing-lg);
}

@media (min-width: 768px) {
  .cta-card {
    border-radius: var(--border-radius-xl);
    padding: var(--spacing-2xl) var(--spacing-3xl);
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-align: right;
    gap: var(--spacing-xl);
  }
}

.cta-title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: white;
  margin-bottom: var(--spacing-xs);
}

@media (min-width: 768px) {
  .cta-title {
    font-size: var(--font-size-2xl);
    margin-bottom: var(--spacing-sm);
  }
}

.cta-desc {
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

@media (min-width: 768px) {
  .cta-desc {
    font-size: var(--font-size-base);
  }
}

.btn-cta {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: 12px 24px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  text-decoration: none;
  transition: all var(--transition-fast);
  white-space: nowrap;
  box-shadow: 0 4px 16px rgba(245, 158, 11, 0.3);
}

@media (min-width: 768px) {
  .btn-cta {
    padding: 14px 28px;
    font-size: var(--font-size-base);
  }
}

.btn-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(245, 158, 11, 0.5);
}
</style>
